import { render, staticRenderFns } from "./OfferEmpty.vue?vue&type=template&id=87512c1c&"
import script from "./OfferEmpty.vue?vue&type=script&lang=js&"
export * from "./OfferEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports